import { EventEmitter } from '@nile/components';
import React, { useEffect } from 'react';
import GlobalChatBox from './GlobalChatBox';
import GlobalChatHook from './GlobalChatHook';

const GlobalChat = () => {
  const {
    tabs,
    activeChat,
    updateTab,
    addTabs,
    removeChat,
    toggleActiveChat,
    updateTabProperty
  } = GlobalChatHook();

  const minimiseGlobalConversation = () => {
    // TODO: Check if we can use toggleActiveChat
    toggleActiveChat(null);
  };

  const closeGlobalConversation = (id) => {
    removeChat(id, { isEventEmitter: true });
  };

  useEffect(() => {
    EventEmitter.subscribe('createGlobalConversation', addTabs);
    EventEmitter.subscribe(
      'minimiseGlobalConversation',
      minimiseGlobalConversation
    );
    EventEmitter.subscribe('closeGlobalConversation', closeGlobalConversation);
    return function cleanup() {
      EventEmitter.unsubscribe('createGlobalConversation');
      EventEmitter.unsubscribe('minimiseGlobalConversation');
      EventEmitter.unsubscribe('closeGlobalConversation');
    };
  }, []);

  return (
    <div
      id="chat-wrapper"
      className="global-conversation-wrapper position-absolute b0"
    >
      <div id="chat-inner" className="chat-inner flex g10 flex-wrap-reverse ">
        {tabs && tabs?.length > 0 && (
          <>
            {tabs.map((chat, i) => {
              const Component = chat?.component || GlobalChatBox;

              return (
                <React.Fragment key={chat?.key || chat?.id || i}>
                  <Component
                    chat={chat} // DATA of params passed from event emitter
                    updateTab={updateTab} // update current tab data
                    updateTabProperty={updateTabProperty} // Update only the current property of current tab
                    toggleActiveChat={toggleActiveChat}
                    activeChat={activeChat} // activeChatId
                    removeChat={removeChat} // Close or remove chat
                  />
                </React.Fragment>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default GlobalChat;
